"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Conversation = _interopRequireDefault(require("./Conversation"));

var _immutable = require("immutable");

var _constants = require("composer-lib/lib/constants");

function isConversationEmpty(conversationThread) {
  var threadWithoutEmptyConverstations = conversationThread.filter(function (conversation) {
    return conversation.comments.length > 0;
  });
  return threadWithoutEmptyConverstations.length === 0;
}

function parseConversations(data) {
  return Object.keys(data).reduce(function (acc, blockKey) {
    var conversations = data[blockKey];

    if (isConversationEmpty(conversations)) {
      // ignore conversations without any actual comments
      return acc;
    }

    var parsedConversations = conversations.reduce(function (parsed, conversation) {
      return parsed.set(conversation.id, _Conversation.default.fromJS(conversation));
    }, (0, _immutable.OrderedMap)());
    return acc.set(blockKey, parsedConversations);
  }, (0, _immutable.OrderedMap)());
}

var DEFAULTS = {
  status: _constants.RequestStatus.UNINITIALIZED,
  deleteCommentStatus: _constants.RequestStatus.UNINITIALIZED,
  deleteCommentId: null,
  deleteConversationStatus: _constants.RequestStatus.UNINITIALIZED,
  deleteConversationId: null,
  blockMap: new _immutable.OrderedMap(),
  selectedBlock: null,
  showAddConversationButtonAtBlock: null,
  openConversations: new _immutable.Set(),
  // Map of dummy conversation ids to their actual conversation object ids
  dummyConversations: new _immutable.Map()
};

var Conversations = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(Conversations, _Record);

  function Conversations() {
    (0, _classCallCheck2.default)(this, Conversations);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Conversations).apply(this, arguments));
  }

  (0, _createClass2.default)(Conversations, null, [{
    key: "fromJS",
    value: function fromJS(data) {
      return new Conversations({
        blockMap: parseConversations(data),
        status: _constants.RequestStatus.SUCCEEDED
      });
    }
  }]);
  return Conversations;
}((0, _immutable.Record)(DEFAULTS));

exports.default = Conversations;
module.exports = exports.default;